import { GET_PRODUCTS_LIST, GET_PRODUCT, GET_KNOWLEDGE_CENTER, ADD_TO_CART, CHECKOUT_ORDER, GET_SITES_LIST } from "./type";

const initialState = {
  viewProducts: null,
  viewProdDetails: null,
  viewDocsList: null,
  viewCart: [],
  checkoutResponse: null,
  sitesData: [],
};

const productsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_PRODUCTS_LIST:
      return {
        ...state,
        viewProducts: payload,
      };
    case GET_PRODUCT:
      return {
        ...state,
        viewProdDetails: payload,
      };
    case GET_KNOWLEDGE_CENTER:
      return {
        ...state,
        viewDocsList: payload,
      };
    case ADD_TO_CART:
      return {
        ...state,
        viewCart: payload,
      };
    case CHECKOUT_ORDER:
      return {
        ...state,
        checkoutResponse: payload,
      };
    case GET_SITES_LIST:
      return {
        ...state,
        sitesData: payload,
      };
    default:
      return { ...state };
  }
};

export default productsReducer;
